// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"154":"d56e835c","346":"8c723440","792":"e1a37d21","873":"f18357d8","919":"fd096025"}[chunkId] + ".js";
};